import React, { useEffect, useState } from 'react';
import { Container, Form, Button, Table, Row, Col } from 'react-bootstrap';
import ManagerService from '../../services/ManagerService';  // Import ManagerService
import './style.css'; // Import CSS
import Select from 'react-select';

const TuyenManager = () => {
    const [tuyen, setTuyen] = useState(null);
    const [changs, setChangs] = useState([]);
    const [tenTuyen, setTenTuyen] = useState('');
    const [tenTuyenList, setTenTuyenList] = useState([]);
    const [isCreatingNewTuyen, setIsCreatingNewTuyen] = useState(false);
    const [newTuyen, setNewTuyen] = useState({
        bien_kiem_soat: '',
        trong_tai: 0,
        ten_tuyen: '',
        km_di: 0,
        km_ve: 0,
        tong: 0,
        khu_vuc: '',
        thoi_gian_ap_dung: ''
    });

    // Lấy danh sách tên tuyến từ API
    useEffect(() => {
        const fetchTenTuyenList = async () => {
            try {
                const response = await ManagerService.getAllTenTuyen();
                const options = response.data.map((ten) => ({
                    value: ten,
                    label: ten,
                }));
                setTenTuyenList(options);
            } catch (error) {
                console.error('Lỗi khi lấy danh sách tên tuyến:', error);
            }
        };
        fetchTenTuyenList();
    }, [isCreatingNewTuyen]);

    const handleChange = (selectedOption) => {
        setTenTuyen(selectedOption ? selectedOption.value : '');
    };

    // Lấy thông tin tuyến và chặng khi nhập tên tuyến
    const fetchTuyenData = async () => {
        try {
            const response = await ManagerService.getTuyen(tenTuyen);
            setTuyen(response.data.tuyen);
            setChangs(response.data.changs);
        } catch (error) {
            console.error('Lỗi khi lấy thông tin tuyến:', error);
        }
    };

    const handleUpdateTuyenChang = async () => {
        try {
            await ManagerService.updateOrInsertTuyenChang(tuyen, changs);
            alert('Cập nhật tuyến và chặng thành công!');
        } catch (error) {            
            alert('Lỗi khi cập nhật tuyến và chặng: '+ error);
            console.error('Lỗi khi cập nhật tuyến và chặng:', error);
        }
    };

    const handleCreateNewTuyen = async () => {
        try {
            await ManagerService.createNewTuyen(newTuyen);
            alert('Tuyến mới đã được tạo thành công!');
            setIsCreatingNewTuyen(false);
            setNewTuyen({
                bien_kiem_soat: '',
                trong_tai: 0,
                ten_tuyen: '',
                km_di: 0,
                km_ve: 0,
                tong: 0,
                khu_vuc: '',
                thoi_gian_ap_dung: ''
            });
        } catch (error) {
            console.error('Lỗi khi tạo tuyến mới:', error);
        }
    };

    const handleDateChange = (value) => {
        const [year, month, day] = value.split('-');
        const newDate = `${day}/${month}/${year}`; // Định dạng lại thành dd/mm/yyyy nếu cần lưu trữ
        setTuyen({ ...tuyen, thoi_gian_ap_dung: newDate });
    };

    const formatToInputDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Thêm số 0 nếu cần
        const day = String(date.getDate()).padStart(2, '0'); // Thêm số 0 nếu cần

        return `${year}-${month}-${day}`; // Định dạng YYYY-MM-DD cho input type="date"
    };

    const handleTimeChange = (value, index, field) => {
        // Kiểm tra định dạng hợp lệ: HH:mm (24 giờ)
        const newChangs = [...changs];
        newChangs[index][field] = value;
        setChangs(newChangs);
    };

    const handleTimeBlur = (value, index, field) => {
        // Kiểm tra định dạng hợp lệ: HH:mm (24 giờ)
        const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        if (timeRegex.test(value) || value === '') {
            const newChangs = [...changs];
            newChangs[index][field] = value;
            setChangs(newChangs);
        } else {
            const newChangs = [...changs];
            newChangs[index][field] = '00:00';
            setChangs(newChangs);
            alert('Vui lòng nhập thời gian hợp lệ theo định dạng HH:mm');
        }
    };

    // Hàm thêm chặng mới vào danh sách changs
    const addNewChang = () => {
        const newChang = {
            diem_di: '',
            diem_den: '',
            thoi_gian_bat_dau: '',
            thoi_gian_ket_thuc: '',
            km_dau: '',
            km_cuoi: '',
            chieu: 'Đi',
        };
        setChangs([...changs, newChang]);
    };

    // Hàm xóa một chặng khỏi danh sách
    const deleteChang = (index) => {
        const newChangs = changs.filter((_, i) => i !== index); // Loại bỏ chặng theo index
        setChangs(newChangs);
    };

    // useEffect để tính toán km_di, km_ve, và tong mỗi khi changs thay đổi
    useEffect(() => {
        const calculateKm = (direction) => {
            const filteredChangs = changs.filter(chang => chang.chieu === direction);
            if (filteredChangs.length === 0) return 0;
            const kmDauValues = filteredChangs.map(chang => Number(chang.km_dau));
            const kmCuoiValues = filteredChangs.map(chang => Number(chang.km_cuoi));
            return Math.max(...kmCuoiValues) - Math.min(...kmDauValues);
        };

        const km_di = calculateKm('Đi');
        const km_ve = calculateKm('Về');
        const tong = km_di + km_ve;

        setTuyen(prevTuyen => ({
            ...prevTuyen,
            km_di,
            km_ve,
            tong,
        }));
    }, [changs]); // Chỉ chạy khi `changs` thay đổi

    return (
        <Container id="htdt-container">
            <h2 className="mt-4 mb-4 text-center">Quản Lý Tuyến và Chặng</h2>

            <Form>
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">Chọn Tên Tuyến</Form.Label>
                    <Col sm="8">
                        <Select
                            options={tenTuyenList}
                            value={tenTuyenList.find((option) => option.value === tenTuyen)}
                            onChange={handleChange}
                            placeholder="Chọn tuyến"
                            isClearable
                        />
                    </Col>
                    <Col sm="2">
                        <Button variant="primary" onClick={fetchTuyenData}>
                            Tìm tuyến
                        </Button>
                    </Col>
                </Form.Group>

                <Button
                    variant="secondary"
                    className="mb-4"
                    onClick={() => setIsCreatingNewTuyen(true)}
                >
                    Tạo Tuyến Mới
                </Button>

                {isCreatingNewTuyen && (
                    <Form>
                        <h3>Tạo Tuyến Mới</h3>
                        {/* Dòng 1: Tên tuyến */}
                        <Form.Group as={Row} className="mb-3">
                            <Col sm="12">
                                <Form.Label>Tên Tuyến</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={newTuyen.ten_tuyen}
                                    onChange={(e) => setNewTuyen({ ...newTuyen, ten_tuyen: e.target.value })}
                                />
                            </Col>
                        </Form.Group>

                        {/* Dòng 2: Biển kiểm soát và Trọng tải */}
                        <Row className="mb-3">
                            <Col sm="6">
                                <Form.Group>
                                    <Form.Label>Biển Kiểm Soát</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={newTuyen.bien_kiem_soat}
                                        onChange={(e) => setNewTuyen({ ...newTuyen, bien_kiem_soat: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm="6">
                                <Form.Group>
                                    <Form.Label>Trọng tải</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={newTuyen.trong_tai}
                                        onChange={(e) => setNewTuyen({ ...newTuyen, trong_tai: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Dòng 3: Khu vực và Thời gian áp dụng */}
                        <Row className="mb-3">
                            <Col sm="6">
                                <Form.Group>
                                    <Form.Label>Khu Vực</Form.Label>
                                    <Form.Select
                                        value={newTuyen.khu_vuc}
                                        onChange={(e) => setNewTuyen({ ...newTuyen, khu_vuc: e.target.value })}
                                    >
                                        <option value="">Chọn Khu Vực</option> {/* Option mặc định */}
                                        <option value="HCM">HCM</option>
                                        <option value="BTE">BTE</option>
                                        <option value="DLK">DLK</option>
                                        <option value="DNI">DNI</option>
                                        <option value="KHA">KHA</option>
                                        <option value="NTN">NTN</option>
                                        <option value="PYN">PYN</option>
                                        <option value="LAN">LAN</option>
                                        <option value="TGG">TGG</option>
                                        <option value="HUG">HUG</option>
                                        <option value="BPC">BPC</option>
                                        <option value="BTN">BTN</option>
                                        <option value="DKG">DKG</option>
                                        <option value="LDG">LDG</option>
                                        <option value="LGD">LGD</option>
                                        <option value="TNH">TNH</option>
                                        <option value="TVH">TVH</option>
                                        <option value="STG">STG</option>
                                        <option value="DTP">DTP</option>
                                        <option value="CMU">CMU</option>
                                        <option value="BLU">BLU</option>
                                        <option value="AGG">AGG</option>
                                        <option value="KGG">KGG</option>
                                        <option value="VLG">VLG</option>
                                        <option value="VTU">VTU</option>
                                        <option value="BDG">BDG</option>
                                        <option value="TTSGN">TTSGN</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm="6">
                                <Form.Group>
                                    <Form.Label>Thời gian áp dụng</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={newTuyen.thoi_gian_ap_dung}
                                        onChange={(e) => setNewTuyen({ ...newTuyen, thoi_gian_ap_dung: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Nút Lưu Tuyến Mới */}
                        <Button variant="success" onClick={handleCreateNewTuyen}>
                            Lưu Tuyến Mới
                        </Button>
                    </Form>
                )}
            </Form>

            {tuyen && (
                <div>
                    <h3 className="mt-4">Thông Tin Tuyến</h3>
                    <Form>
                        {/* Dòng 1: Biển kiểm soát và Trọng tải */}
                        <Row>
                            <Col sm="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Biển Kiểm Soát</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tuyen.bien_kiem_soat}
                                        onChange={(e) =>
                                            setTuyen({ ...tuyen, bien_kiem_soat: e.target.value })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Trọng tải</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tuyen.trong_tai}
                                        onChange={(e) =>
                                            setTuyen({ ...tuyen, trong_tai: e.target.value })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Dòng 2: Khu vực và Km đi */}
                        <Row>
                            <Col sm="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Km đi</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tuyen.km_di}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Km về</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tuyen.km_ve}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Dòng 3: Km về và Thời gian áp dụng */}
                        <Row>
                            <Col sm="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Khu vực</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={tuyen.khu_vuc}
                                        readOnly
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Thời gian áp dụng</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={tuyen.thoi_gian_ap_dung ? formatToInputDate(tuyen.thoi_gian_ap_dung) : ''}
                                        onChange={(e) => handleDateChange(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Dòng 4: Nút cập nhật */}
                        <Row>
                            <Col className="text-end">
                                <Button variant="success" onClick={handleUpdateTuyenChang}>
                                    Cập Nhật Tuyến
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            )}

            <h3 className="mt-5">Thông Tin Chặng</h3>
            <Table striped bordered hover className="mt-3 custom-table">
                <thead>
                    <tr>
                        <th style={{ width: '5%' }}>#</th>
                        <th style={{ width: '18%' }}>Điểm Đi</th>
                        <th style={{ width: '18%' }}>Điểm Đến</th>
                        <th style={{ width: '14%' }}>Thời Gian Bắt Đầu</th>
                        <th style={{ width: '14%' }}>Thời Gian Kết Thúc</th>
                        <th style={{ width: '9%' }}>Km Đầu</th>
                        <th style={{ width: '9%' }}>Km Cuối</th>
                        <th style={{ width: '7%' }}>Chiều</th>
                        <th style={{ width: '6%' }}>Xóa</th> {/* Thêm cột Xóa */}
                    </tr>
                </thead>
                <tbody>
                    {changs.map((chang, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={chang.diem_di}
                                    onChange={(e) => {
                                        const newChangs = [...changs];
                                        newChangs[index].diem_di = e.target.value;
                                        setChangs(newChangs);
                                    }}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={chang.diem_den}
                                    onChange={(e) => {
                                        const newChangs = [...changs];
                                        newChangs[index].diem_den = e.target.value;
                                        setChangs(newChangs);
                                    }}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={chang.thoi_gian_bat_dau || ''}
                                    placeholder="HH:mm"
                                    onChange={(e) => handleTimeChange(e.target.value, index, 'thoi_gian_bat_dau')}
                                    onBlur={(e) => handleTimeBlur(e.target.value, index, 'thoi_gian_bat_dau')}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={chang.thoi_gian_ket_thuc || ''}
                                    placeholder="HH:mm"
                                    onChange={(e) => handleTimeChange(e.target.value, index, 'thoi_gian_ket_thuc')}
                                    onBlur={(e) => handleTimeBlur(e.target.value, index, 'thoi_gian_ket_thuc')}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="number"
                                    value={chang.km_dau}
                                    onChange={(e) => {
                                        const newChangs = [...changs];
                                        newChangs[index].km_dau = e.target.value;
                                        setChangs(newChangs);
                                    }}
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="number"
                                    value={chang.km_cuoi}
                                    onChange={(e) => {
                                        const newChangs = [...changs];
                                        newChangs[index].km_cuoi = e.target.value;
                                        setChangs(newChangs);
                                    }}
                                />
                            </td>
                            <td>
                                <Form.Select
                                    value={chang.chieu}
                                    onChange={(e) => {
                                        const newChangs = [...changs];
                                        newChangs[index].chieu = e.target.value;
                                        setChangs(newChangs);
                                    }}
                                >
                                    <option value="Đi">Đi</option>
                                    <option value="Về">Về</option>
                                </Form.Select>
                            </td>
                            <td>
                                <Button variant="danger" onClick={() => deleteChang(index)}>
                                    Xóa
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Button variant="secondary" className="mt-3" onClick={addNewChang}>
                Thêm Chặng
            </Button>
        </Container>
    );
};

export default TuyenManager;
